import { render, staticRenderFns } from "./EditDomain.vue?vue&type=template&id=3a02a4fd&scoped=true&"
import script from "./EditDomain.vue?vue&type=script&lang=js&"
export * from "./EditDomain.vue?vue&type=script&lang=js&"
import style0 from "./EditDomain.vue?vue&type=style&index=0&id=3a02a4fd&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a02a4fd",
  null
  
)

export default component.exports